import { render, staticRenderFns } from "./FileDropZone.vue?vue&type=template&id=841c52b2&scoped=true&"
import script from "./FileDropZone.vue?vue&type=script&lang=js&"
export * from "./FileDropZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841c52b2",
  null
  
)

export default component.exports